import { request } from '@/utils/request';
// 获取医械商品目录列表
export const getPageMdm = params => {
	return request({ url: '/product/public/getPageMdm', method: 'POST', params: params });
};

// 获取医械商品目录详情
export const getMdm = params => {
	return request({ url: '/product/public/getMdm', method: 'GET', params: params });
};
